import { instance } from "libs/api";

import { DriverDeliveriesReportItem } from "../../financial.types";

/**
 * Avatars are read through the API's existing media download route rather than
 * from their `url`: jsPDF needs the actual bytes, and a cross-origin `fetch` to
 * the media CDN does not get them. That route exists for exactly this reason.
 */
const requestAvatar = async (
  mediaId: string,
  contentType: string
): Promise<string | null> => {
  try {
    const buffer = await instance.get<unknown, ArrayBuffer>(
      `media/${mediaId}/download`,
      { responseType: "arraybuffer" }
    );

    const bytes = new Uint8Array(buffer);

    let binary = "";

    for (const byte of bytes) binary += String.fromCharCode(byte);

    return `data:${contentType || "image/png"};base64,${btoa(binary)}`;
  } catch {
    // A missing or unreadable avatar simply leaves the block without a picture.
    return null;
  }
};

/** Driver id -> avatar as a data URL, for the drivers whose image could be read. */
export const loadDriverAvatars = async (
  items: DriverDeliveriesReportItem[]
): Promise<Map<string, string>> => {
  const avatars = new Map<string, string>();

  await Promise.all(
    items.map(async ({ driver }) => {
      if (!driver.image?.id) return;

      const dataUrl = await requestAvatar(
        driver.image.id,
        driver.image.contentType
      );

      if (dataUrl) avatars.set(driver.id, dataUrl);
    })
  );

  return avatars;
};
